import React from 'react'
import AddDefaultIconForm from './ModalContent/AddDefaultIconForm'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { defaultIconStore } from 'state/listing/defaultIcon'

const AddDefaultIconModal = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { addDefaultIconModal, setAddDefaultIconModal, defaultData } =
    defaultIconStore(store => ({
      addDefaultIconModal: store.addDefaultIconModal,
      setAddDefaultIconModal: store.setAddDefaultIconModal,
      defaultData: store.defaultData,
    }))

  return (
    <CustomModal
      openModal={addDefaultIconModal}
      closeModal={setAddDefaultIconModal}
      title="Add Default Icon"
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText={defaultData ? 'Update Icon' : 'Add Icon'}
          btnType="primary"
          onSubmit={handleSubmit}
        />
      }
    >
      <AddDefaultIconForm form={form} />
    </CustomModal>
  )
}

export default AddDefaultIconModal
